"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSection = void 0;
const confirm_1 = __importDefault(require("@app/component/modals/confirm"));
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const react_1 = __importDefault(require("react"));
const mfa_section_1 = require("./mfa-section");
const resetLocalStorageKeepAuth = () => {
    localStorage.clear();
    window.location.reload();
};
const AdvancedSection = () => {
    const { openModal } = (0, use_modal_1.useModal)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ui_1.Spacing, { size: ui_1.Spacing.SIZES.SIZE_16, type: ui_1.Spacing.TYPES.VERTICAL },
            react_1.default.createElement("div", { style: {
                    display: 'grid',
                    gridTemplateRows: 'auto',
                    gridTemplateColumns: '50%',
                    gap: '1rem',
                } },
                react_1.default.createElement(ui_1.Button, { onClick: () => openModal(confirm_1.default, {
                        onConfirm: () => resetLocalStorageKeepAuth(),
                        title: (0, util_1.t)('DELETE_LOCAL_STORAGE_CONFIRM'),
                        type: ui_1.Alert.TYPES.WARNING,
                        confirmLabel: (0, util_1.t)('CONFIRM'),
                        cancelLabel: (0, util_1.t)('CANCEL'),
                        subtitle: (0, util_1.t)('DELETE_LOCAL_SETTINGS_SUBTITLE'),
                    }), ico: 'delete', color: 'RED' }, (0, util_1.t)('DELETE_LOCAL_SETTINGS'))),
            react_1.default.createElement(mfa_section_1.MfaSection, null))));
};
exports.AdvancedSection = AdvancedSection;
